<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import {templateExquery} from '../../../../api/bbmb.js';
import {
    dgsh_queryAuditStatus,
    dgsh_content,
    dgsh_cwdata,
    dgsh_cellDefine,
    dgsh_sjdata,
    dgsh_save,
    dgsh_delete,
    dgsh_completeFlow,
    dgsh_update,
    dgsh_queryCompanyShuibDict,
    dgsh_getCommentsByIds,
    queryAttachmentList,
    manuscriptUploadFile,
    annexadd,
	auditFlow
} from '../../../../api/dgsh.js';
import shpz from '../../AuditCenter/shpz/index.vue';
import splc from '../../AuditCenter/splc/index.vue';
import SalesTaxReport from '../../Applicationdraft/Draftgeneration/SalesTaxReport/index.vue';
import AssetsAndLiabilities from '../../Applicationdraft/Draftgeneration/AssetsAndLiabilities/index.vue';
import AssetsAndLiabilitiesY from '../../Applicationdraft/Draftgeneration/AssetsAndLiabilitiesY/index.vue';
import corporateIncomeTax from '../../Applicationdraft/Draftgeneration/corporateIncomeTax/index.vue';
import corporateIncomeTax_V2 from '../../Applicationdraft/Draftgeneration/corporateIncomeTax_V2/index.vue';
import ConsolidatedStatement from '../../Applicationdraft/Draftgeneration/ConsolidatedStatement/index.vue';
import SmallScaleVAT from '../../Applicationdraft/Draftgeneration/SmallScaleVAT/index.vue';
import valueAddedTax from '../../Applicationdraft/Draftgeneration/valueAddedTax/index.vue';
import TaxableService from '../../Applicationdraft/Draftgeneration/TaxableService/index.vue';
import DisabilityPayment from '../../Applicationdraft/Draftgeneration/DisabilityPayment/index.vue';
import GeneralReturn from '../../Applicationdraft/Draftgeneration/GeneralReturn/index.vue';
import GeneralReturnF from '../../Applicationdraft/Draftgeneration/GeneralReturnF/index.vue';
import BalanceSheet from '../../Applicationdraft/Draftgeneration/BalanceSheet/index.vue';
import AdditionalTax from '../../Applicationdraft/Draftgeneration/AdditionalTax/index.vue';
import config from '../../../../../configHttp.js';
import FileToSeeplus from '../../../common/FileToSeeplus/index.vue';
import uploadFileplus from '../../../common/uploadFileplus/index.vue';
export default {
    name: 'dgsh',
    components: {
        shpz,
        splc,
        SalesTaxReport,
        AssetsAndLiabilities,
        AssetsAndLiabilitiesY,
        corporateIncomeTax,
        corporateIncomeTax_V2,
        SmallScaleVAT,
        valueAddedTax,
        ConsolidatedStatement,
        FileToSeeplus,
        uploadFileplus,
        TaxableService,
        DisabilityPayment,
        GeneralReturn,
        BalanceSheet,
        GeneralReturnF,
		AdditionalTax
    },
    data: function () {
        return {
            //查看附件
            toseediag: false,
            tableseeData: [{}],
            zhongdianxxfeny: getdata().zhongdianxxfeny,
            baobiesjfenye: getdata().baobiesjfenye,
            choosecompanyCode: null,
            chooseshuibId: null,
            headseeData: getdata().headseeData,
            id: '',
            companyCodes:'',
            companyNo: '',
            companyCode: '',
            //添加审核内容数据
            shengheneirong: {
                chaiwusj: {},
                baobiaosju: {},
                suijusju: {}
            },
            bbztsb: [
                {
                    label: '草稿',
                    value: '0'
                },
                {
                    label: '未填写',
                    value: '-1'
                },
                {
                    label: '底稿',
                    value: '1',
                    color: '#6DC0FF'
                },
                {
                    label: '审核中',
                    value: '2',
                    color: '#F7B500'
                },
                {
                    label: '审核成功',
                    value: '3',
                    color: '#0065B1'
                },
                {
                    label: '审核失败',
                    value: '4',
                    color: '#E02020'
                },
                {
                    label: '申报中',
                    value: '5',
                    color: '#F7B500'
                },
                {
                    label: '申报成功',
                    value: '6',
                    color: '#0065B1'
                },
                {
                    label: '申报失败',
                    value: '7',
                    color: '#E02020'
                },
                // {
                // 	label: "申报作废",
                // 	value: "8"
                // },
                {
                    label: '缴款成功',
                    value: '9'
                },
                {
                    label: '缴款失败',
                    value: '10'
                },
                {
                    label: '缴款中',
                    value: '11'
                },
                {
                    label: '申报作废中',
                    value: '12'
                },
                // {
                // 	label: "草稿",
                // 	value: "13"
                // },
                {
                    label: '作废成功',
                    value: '14'
                },
                {
                    label: '取消审核',
                    value: '15'
                },
                // {
                // 	label: "发起PDF下载",
                // 	value: "16"
                // },
                {
                    label: '作废失败',
                    value: '17'
                }
                // {
                // 	label: "PDF下载失败",
                // 	value: "18"
                // }
            ],
            formdata: {
                type: '',
                name: '',
                description: ''
            },
            formlist: getdata().formlist,
            upfile: {},
						ApprovalProcess:false,
            updiag: false,
            paginationfile: getdata().paginationfile,
            chaxunleix: '1',
            searchdata: getdata().searchdata,
            searchlist: [],
            paginationywkm: getdata().paginationywkm,
            outlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            tableData: [],
            shaidiag: false,
            searchdiag: false,
            shdiag: false,
            headDatash: getdata().headDatash,
            tableDatash: [],
            addshdiag: false,
            choseywdiag: false,
            headDataxzyw: getdata().headDataxzyw,
            tableDatashxzyw: [],
            chosebbdiag: false,
            headDatabb: getdata().headDatabb,
            tableDatabb: [{}],
            tablekey: 0,
            selectrow: {},
            radioNow: 0,
            bbgzssk: '',
            selectrowkm: {},
            radioNowkm: 0,
            overlength: 0,
            qufem: null,
            xiangmmc: '',
            ywkmssk: '',
            suosq: this.$getdefultMonth(),
            bianjuid: '',
            detailtype: '',
            seeNow: false,
            Saleparams: null,
            title: '',
            showbox: {
                hjbhs: false,
                yhs: false,
                zzs: false,
                cwbbybqyyzx: false,
                cwbbybqywzx: false,
                cwbbxqy: false,
                zzsxgm: false,
                qysdsA: false,
                qysdsA_V2: false,
                cztds: false,
                fcs: false,
                cwbbkjzd: false,
                cbj: false,
                whsy: false,
                tysl: false,
                tygh: false,
                tylj: false,
                ty: false,
                noty:false,
                xfs:false,
            },
            ReviewAndApprovalNote: false,
            dataSources: {},
            differentiate: '',
            textarea: '',
            name: '',
            // 模板列表
            templateDataMap: {},
        };
    },
    created() {
        this.chaxunshengheneirong();
        this.chaxsbzl();
        templateExquery({current: 1, size: 50}).then(res => {
          this.templateDataMap = res.data.data.records.reduce((map, item) => {
            map[item.id] = item;
            return map;
          }, {});
        })
    },
    mounted() {},
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        //批量通过驳回
        Batch(k) {
            let taskId = [];
            let table = this.$refs.tablebox.getSelectionval();
			
			var istype=false
            table.map((item) => {
				if(item.type!=1){
					istype=true
				}
                taskId.push(item.taskId);
            });
			
			if(istype){
				this.$message.warning(`选择的数据中存在不能操作的数据。`);
				return
			}
			
			
            if (taskId.length != 0) {
                let params = {
                    taskId: taskId.join(','),
                    adopt: k
                };
                dgsh_completeFlow(params).then((res) => {
                    this.chaxunshengheneirong();
                });
            } else {
                this.$message.warning(`请选择你要${k == 1 ? '通过' : '拒绝'}的数据`);
            }
        },
        //上传文件
        closeupdiag() {
            this.updiag = false;
        },
        fordownloadpl(e) {
            if (this.$emptyandnull(e)) {
                this.$message.error('请选择要下载的数据');
                return false;
            }
            let params = {
                downUrl: config.baseURL + 'manuscript/annex/downloads',
                typeObj: {
                    toForm: false,
                    fileType: 'zip',
                    failUrl:this.$winURl
                },
                params: {
                    attIds: e.map((item) => item.id),
                    companyCode: this.choosecompanyCode,
                    shuibId: this.chooseshuibId
                }
            };
            this.$downloadcommon(params);
        },
        forsubmit(e) {
            if (this.$emptyandnull(this.upfile.fileUrl)) {
                this.$message.error('请选择要上传的文件');
                return false;
            }
            let params = JSON.parse(JSON.stringify(this.formdata));
            params.fileName = this.upfile.fileName;
            params.fileUrl = this.upfile.fileUrl;
            params.id = this.upfile.id;
            annexadd(params).then((res) => {
                if (res.data.code == 1) {
                    this.chaxunshengheneirong();
                    this.chaxsbzl();
                    this.updiag = false;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        openUpfileplus(id) {
            Object.keys(this.formdata).map((key) => (this.formdata[key] = ''));
            Object.keys(this.upfile).map((key) => (this.upfile[key] = ''));
            this.upfile.id = id;
            this.updiag = true;
        },
        getuploadparams(e) {
            manuscriptUploadFile({
                file: e.upfile
            }).then((res) => {
                if (res.data.code == 1) {
                    this.upfile.fileName = res.data.data.fileName;
                    this.upfile.fileUrl = res.data.data.fileUrl;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        forseefile(e) {
            this.chooseid = e.id;
            this.choosecompanyCode = e.companyCode;
            this.chooseshuibId = e.shuibId;
            let params = {
                id: e.id
            };
            params.current = this.paginationfile.pageNum;
            params.size = this.paginationfile.pageSize;
            queryAttachmentList(params).then((res) => {
                this.tableseeData = res.data.data.records;
                this.paginationfile.total = res.data.data.total;
                this.toseediag = true;
            });
        },
        fordownloadFile(e) {
            let arr = e.fileName.split('.');
            let params = {
                downUrl: config.baseURL + 'manuscript/annex/downloads',
                typeObj: {
                    toForm: false,
                    fileType: e.fileName.split('.')[arr.length - 1],
                    fileName: e.fileName.split('.')[0],
                    failUrl:this.$winURl
                },
                params: {
                    attIds: [e.id],
                    companyCode: this.choosecompanyCode,
                    shuibId: this.chooseshuibId
                }
            };
            this.$downloadcommon(params);
        },
        closetoseediag() {
            this.toseediag = false;
        },
        sizechangefile() {
            this.paginationfile.pageSize = e;
        },
        currentChangefile() {
            this.paginationfile.pageNum = e;
        },
        fodeleteFile(e) {
            this.$showConfirm({
                message: '确认删除?'
            }).then((res) => {
                if (res == 'confirm') {
                    annexdelete([e.id]).then((res) => {
                        if (res.data.code == 1) {
                            this.$message.success('删除成功');
                            this.paginationfile.paginationkey++;
                            this.paginationfile.pageNum = '1';
                            this.forseefile({
                                id: this.chooseid,
                                companyCode: this.choosecompanyCode,
                                shuibId: this.chooseshuibId
                            });
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                }
            });
        },
        postil(v, k) {
            this.dataSources = v;
            this.differentiate = k;
            if (k == 1 || k == 2) {
                this.textarea = '';
                this.name = '';
                let params = { id: this.dataSources.id };
                dgsh_getCommentsByIds(params).then((res) => {
                    if (res.data.code == 1) {
                        if (res.data.data.length > 0) {
                            this.list = res.data.data;
                        }
                        if (config.company == 'mb') {
                            this.title = '审核批注';
                        } else {
                            if (k == 1) {
                                this.edit = true;
                                this.title = '通过审核批注';
                            } else if (k == 2) {
                                this.edit = true;
                                this.title = '拒绝审核批注';
                            }
                            this.ReviewAndApprovalNote = true;
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }else{
							let params = { id: this.dataSources.id };
							auditFlow(params).then(res=>{
								if(res.data.code==1){
									this.list = res.data.data
									this.ApprovalProcess = true
								}else{
									this.$message.error(res.data.msg)
								}
							})
						}
        },
				splc(){
					this.ApprovalProcess = false
				},
        Answer_ReviewAndApprovalNote(e) {
            this.ReviewAndApprovalNote = false;
        },
        fortosee(item) {
            this.detailtype = 'tosee';
            this.seeNow = true;
            this.Saleparams = item;
            let version = this.templateDataMap[item.templateId].cank1;
            if (!version) {
              version = "";
            }
            this.showbox[item.sbbm + version] = true;
        },
        forbacksale() {
            Object.keys(this.showbox).map((key) => (this.showbox[key] = false));
        },
        //查询申报种类
        chaxsbzl() {
            dgsh_queryCompanyShuibDict().then((res) => {
                getdata().searchlist.forEach((ve, k) => {
                    if (ve.prop == 'shuiBid') {
                        res.data.data.forEach((v) => {
                            getdata().searchlist[k].selectval.push({
                                label: v.reportName,
                                value: v.id
                            });
                        });
                    }
                    this.searchlist = getdata().searchlist;
                });
            });
        },
        //操作
        shengq(v, k, txt) {
            if (k != '' && k != null) {
                let params = {};
                params.adopt = k;
                params.comment = txt;
                params.taskId = v.taskId;
                dgsh_completeFlow(params).then((res) => {
                    if (res.data.code == 1) {
                    } else {
                    }
                    // this.zhongdianxxfeny.paginationkey++;
                    // this.zhongdianxxfeny.pageNum = "1";
                    // this.zdianshenghe();
                    this.chaxunshengheneirong();
                });
            }
            this.ReviewAndApprovalNote = false;
        },
        //编辑
        bianjnn(e) {
            this.xiangmmc = e.xiangmName;
            this.shengheneirong.chaiwusj = { yewkmCode: e.caiwCode };
            this.shengheneirong.suijusju = { yewkmCode: e.shuijCode };
            this.shengheneirong.baobiaosju = { cellCode: e.cellCode };
            this.bianjuid = e.id;
            this.addshdiag = true;
        },
        //删除
        shangczdxx(id) {
            this.$showConfirm({
                message: '确认删除?'
            }).then((res) => {
                if (res == 'confirm') {
                    dgsh_delete({
                        id
                    }).then((res) => {
                        if (res.data.code == 1) {
                            this.$message.success('删除成功');
                            this.zhongdianxxfeny.paginationkey++;
                            this.zhongdianxxfeny.pageNum = '1';
                            this.zdianshenghe();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                }
            });
        },

        //添加
        addzongdianshxx() {
            let params = {};
            params.caiwCode = this.shengheneirong.chaiwusj.yewkmCode;
            params.shuijCode = this.shengheneirong.suijusju.yewkmCode;
            params.cellCode = this.shengheneirong.baobiaosju.cellCode;
            params.xiangmName = this.xiangmmc;
            params.shuibId = this.id;
            params.suosq = this.suosq;
            params.companyCode = this.companyCodes
            if (params.xiangmName == null || params.xiangmName == '') {
                this.$message.error('请填写项目名称');
                return;
            }
            // if( params.shuijCode==null|| params.shuijCode==""){
            // 		   this.$message.error("请选择税局数据");
            //    return;
            // }
            if (params.cellCode == null || params.cellCode == '') {
                this.$message.error('请选择报表数据');
                return;
            }

            if (this.bianjuid != '') {
                //修改
                params.id = this.bianjuid;
                dgsh_update(params).then((res) => {
                    if (res.data.data) {
                        this.$message.success('修改成功');
                        this.zhongdianxxfeny.paginationkey++;
                        this.zhongdianxxfeny.pageNum = '1';
                        this.zdianshenghe();
                    } else {
                        this.$message.error('修改失败');
                    }
                });
            } else {
                //添加
                dgsh_save(params).then((res) => {
                    if (res.data.data) {
                        this.$message.success('添加成功');
                        this.zhongdianxxfeny.paginationkey++;
                        this.zhongdianxxfeny.pageNum = '1';
                        this.zdianshenghe();
                    } else {
                        this.$message.error('添加失败');
                    }
                });
            }

            this.addshdiag = false;
        },
        fanhui() {
            this.addshdiag = false;
        },
        //添加的弹框
        addshdiagffa() {
            this.xiangmmc = '';
            this.bianjuid = '';
            this.shengheneirong.chaiwusj = {};
            this.shengheneirong.suijusju = {};
            this.shengheneirong.baobiaosju = {};
            this.addshdiag = true;
        },
        //导出底稿审核
        digaoshenghedaochu() {
            let data = JSON.parse(JSON.stringify(this.searchdata));
            data.current = this.pagination.pageNum;
            data.size = this.pagination.pageSize;
            data.sort = '';
            data.order = '';
            data.type = this.chaxunleix;
            let params = {
                downUrl: config.baseURL + 'audit/manuscript/export/audit',
                typeObj: {
                    toForm: false,
                    fileName: '底稿审核' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
                    fileType: 'xlsx',
                    failUrl:this.$winURl
                },
                params: data
            };
            this.$downloadcommon(params);
        },
        //导出审核内容
        shengheneirongdaochu() {
            let data = {};
            data.suosq = this.suosq;
            data.current = this.zhongdianxxfeny.pageNum;
            data.size = this.zhongdianxxfeny.pageSize;
            data.sort = '';
            data.order = '';
            data.shuibId = this.id;
            data.companyNo = this.companyNo;
            let params = {
                downUrl: config.baseURL + 'audit/export/audit/content',
                typeObj: {
                    toForm: false,
                    fileName: '审核内容' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
                    fileType: 'xlsx',
                    failUrl:this.$winURl
                },
                params: data
            };
            this.$downloadcommon(params);
        },
        qingk() {
            this.xiangmmc = '';
            this.bianjuid = '';
            this.shengheneirong.chaiwusj = {};
            this.shengheneirong.suijusju = {};
            this.shengheneirong.baobiaosju = {};
        },
        //搜索财务数据
        caiwusju(e) {
            this.ywkmssk = '';
            this.radioNowkm = '';
            if (e != 1) {
                this.paginationywkm = { pageNum: 1, pageSize: 50, total: 0, paginationkey: 0 };
            }
            this.selectrowkm = {};
            this.qufem = 0;
            this.choseywdiag = true;
            let params = {};
            params.companyCode = this.companyCode;
            params.current = this.paginationywkm.pageNum;
            params.order = '';
            params.search = '';
            params.shuibiId = this.id;
            params.size = this.paginationywkm.pageSize;
            params.sort = '';
            dgsh_cwdata(params).then((res) => {
                this.paginationywkm.total = res.data.data.total;
                this.tableDatashxzyw = res.data.data.records;
            });
        },
        //搜索税局数据
        suijusju(e) {
            this.ywkmssk = '';
            this.radioNowkm = '';
            if (e != 1) {
                this.paginationywkm = { pageNum: 1, pageSize: 50, total: 0, paginationkey: 0 };
            }
            this.selectrowkm = {};
            this.qufem = 1;
            this.choseywdiag = true;
            let params = {};
            params.companyCode = this.companyCode;
            params.current = this.paginationywkm.pageNum;
            params.order = '';
            params.search = '';
            params.shuibiId = this.id;
            params.size = this.paginationywkm.pageSize;
            params.sort = '';
            dgsh_sjdata(params).then((res) => {
                this.paginationywkm.total = res.data.data.total;
                this.tableDatashxzyw = res.data.data.records;
            });
        },
        ywkmsskchax() {
            this.paginationywkm = { pageNum: 1, pageSize: 50, total: 0, paginationkey: 0 };
            if (this.qufem == 0) {
                let params = {};
                params.companyCode = this.companyCode;
                params.current = 1;
                params.order = '';
                params.search = this.ywkmssk;
                params.shuibiId = this.id;
                params.size = this.paginationywkm.pageSize;
                params.sort = '';
                dgsh_cwdata(params).then((res) => {
                    this.paginationywkm.total = res.data.data.total;
                    this.tableDatashxzyw = res.data.data.records;
                });
            } else if (this.qufem == 1) {
                let params = {};
                params.companyCode = this.companyCode;
                params.current = this.paginationywkm.pageNum;
                params.order = '';
                params.search = this.ywkmssk;
                params.shuibiId = this.id;
                params.size = this.paginationywkm.pageSize;
                params.sort = '';
                dgsh_sjdata(params).then((res) => {
                    this.paginationywkm.total = res.data.data.total;
                    this.tableDatashxzyw = res.data.data.records;
                });
            }
        },
        radiochangekm(row) {
            this.selectrowkm = row;
        },
        kwkmxzbc() {
            if (this.qufem == 0) {
                this.shengheneirong.chaiwusj = this.selectrowkm;
            } else if (this.qufem == 1) {
                this.shengheneirong.suijusju = this.selectrowkm;
            }
            this.choseywdiag = false;
        },
        sizechangeywkm(e) {
            if (this.qufem == 0) {
                this.paginationywkm.pageSize = e;
                this.caiwusju(1);
            } else if (this.qufem == 1) {
                this.paginationywkm.pageSize = e;
                this.suijusju(1);
            }
        },
        currentChangeywkm(e) {
            if (this.qufem == 0) {
                this.paginationywkm.pageNum = e;
                this.caiwusju(1);
            } else if (this.qufem == 1) {
                this.paginationywkm.pageNum = e;
                this.suijusju(1);
            }
        },
        //搜索报表数据
        baobiaosju() {
            this.bbgzssk = '';
            this.radioNow = '';
            this.chosebbdiag = true;
            let params = {};
            params.companyCode = this.companyCode;
            params.current = this.baobiesjfenye.pageNum;
            params.order = '';
            params.search = '';
            params.shuibiId = this.id;
            // params.shuibiId = 1;
            params.size = this.baobiesjfenye.pageSize;
            params.sort = '';
            dgsh_cellDefine(params).then((res) => {
                this.baobiesjfenye.total = res.data.data.total;
                this.tableDatabb = res.data.data.records;
            });
        },
        sizechangebbgz(e) {
            this.baobiesjfenye.pageSize = e;
            this.baobiaosju();
        },
        currentChangebbgz(e) {
            this.baobiesjfenye.pageNum = e;
            this.baobiaosju();
        },
        //报表格子搜索框
        baobiaogessskchax() {
            let params = {};
            params.companyCode = this.companyCode;
            params.current = 1;
            params.order = '';
            params.search = this.bbgzssk;
            params.shuibiId = this.id;
            // params.shuibiId = 1;
            params.size = this.baobiesjfenye.pageSize;
            params.sort = '';
            dgsh_cellDefine(params).then((res) => {
                this.baobiesjfenye.total = res.data.data.total;
                this.tableDatabb = res.data.data.records;
            });
        },
        //选择报表数据
        radiochange(row) {
            this.selectrow = row;
        },
        bbgzdr() {
            this.shengheneirong.baobiaosju = this.selectrow;
            this.chosebbdiag = false;
        },
        //重点信息审核数据查询
        zdianshenghe(e) {
            if (e != undefined) {
                this.id = e.shuibId;
                this.companyNo = e.companyNo;
                this.companyCode = e.companyCode;
                this.suosq = e.shuikssqTime;
                this.companyCodes = e.companyCode
            }
            let params = {};
            params.companyNo = this.companyNo;
            params.current = this.zhongdianxxfeny.pageNum;
            params.size = this.zhongdianxxfeny.pageSize;
            params.sort = '';
            params.order = '';
            params.shuibId = this.id;
            params.suosq = this.suosq;
            dgsh_content(params).then((res) => {
                this.zhongdianxxfeny.total = res.data.data.total;
                this.tableDatash = res.data.data.records;
                if (e != undefined) {
                    this.shdiag = true;
                }
            });
        },
        sizechangezd(e) {
            this.zhongdianxxfeny.pageSize = e;
            this.zdianshenghe();
        },
        currentChangezd(e) {
            this.zhongdianxxfeny.pageNum = e;
            this.zdianshenghe();
        },
        chaxunshengheneirong() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.sort = '';
            params.order = '';
            params.type = this.chaxunleix;
            params.shuikssqTime = this.suosq;
            dgsh_queryAuditStatus(params).then((res) => {
                this.pagination.total = res.data.data.total;
                this.tableData = res.data.data.records;
            });
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.chaxunshengheneirong();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.chaxunshengheneirong();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.chaxunshengheneirong();
        },
        forRefresh(index) {
            this.chaxunleix = index;
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.chaxunshengheneirong();
        },

        forUpdateSearch() {
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
            this.shaidiag = false;
        },
        closeshaidiag() {
            this.shaidiag = false;
        }
    }
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
